import { render, staticRenderFns } from "./record-form.vue?vue&type=template&id=0bcaa3b5&scoped=true"
import script from "./record-form.vue?vue&type=script&lang=js"
export * from "./record-form.vue?vue&type=script&lang=js"
import style0 from "./record-form.vue?vue&type=style&index=0&id=0bcaa3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaa3b5",
  null
  
)

export default component.exports